import { render, staticRenderFns } from "./DirectoryManager.vue?vue&type=template&id=24328877&scoped=true"
import script from "./DirectoryManager.vue?vue&type=script&lang=js"
export * from "./DirectoryManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24328877",
  null
  
)

export default component.exports